import React from 'react';
import ProductPage from '../product_page/productPage';

const Featured = () => {
    return <ProductPage
        page_title={'Featured'}
        initial_filters={{featured: true}}
        seo={{
            title: "Featured Fashion | The Sidewalk",
            description: "Discover our hand-picked featured fashion items from the best emerging brands."
        }}
    />;
};

export default Featured;